import { BuildingReadModel, SpaceReadModel } from '@client/api';
import { createContext, useContext } from 'react';

interface SpaceContextType {
  space: BuildingReadModel | SpaceReadModel | undefined;
  isFetching: boolean;
}

export const SpaceContext = createContext<SpaceContextType | undefined>(undefined);

export function useSpace() {
  const context = useContext(SpaceContext);
  if (!context) {
    throw new Error('useSpace must be used within a SpaceProvider');
  }
  return context;
}
